<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (tap)="cancelCallLog()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Call Log</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list>
        <ion-item *ngFor="let call of callList" (click)="createOpp(call)">
            <label>
            <p>{{ call.name ? call.name : 'Unknown' }}</p>
            <p>{{ call.number }}</p>
            </label>
            <ion-icon [name]="setStyle(call.type)[0]" [color]="setStyle(call.type)[1]" slot="end"></ion-icon>
        </ion-item>
    </ion-list>

</ion-content>
